import React, { useEffect, useState } from 'react';
import styles from './AlertBox.module.css';
import { FiAlertTriangle, FiInfo, FiAlertCircle, FiX } from 'react-icons/fi';

const AlertBox = ({ type = 'error', message, onDismiss, actions }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (onDismiss) {
      const timer = setTimeout(() => {
        setVisible(false);
        setTimeout(onDismiss, 500);
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [message, onDismiss]);

  if (!message) return null;

  const getIcon = () => {
    switch (type) {
      case 'info':
        return <FiInfo className={styles['alert-icon']} />;
      case 'warning':
        return <FiAlertTriangle className={styles['alert-icon']} />;
      case 'error':
      default:
        return <FiAlertCircle className={styles['alert-icon']} />;
    }
  };

  return (
    <div className={`${styles['alert-box']} ${styles[type]} ${!visible ? styles.fadeOut : ''}`}>
      <div className={styles['alert-content']}>
        {getIcon()}
        <span>{message}</span>
      </div>
      <div className={styles['alert-actions']}>
        {actions}
        {onDismiss && (
          <button className={styles['alert-dismiss']} onClick={onDismiss}>
            <FiX />
          </button>
        )}
      </div>
    </div>
  );
};

export default AlertBox; 